/**
 * Énumération des versions de fonctionnalités mobile
 * (miroir de com.notilus.data.login.MobileConfig.TypeVersion)
 */
export enum TypeVersion {
    UNDEFINED = 'UNDEFINED',
    LAST_FEATURES = 'LAST_FEATURES',
    PREVIOUS_FEATURES = 'PREVIOUS_FEATURES'
}

/**
 * Configuration de l'application mobile
 * (miroir de com.notilus.data.login.MobileConfig)
 */
export class MobileConfig {
    /** Identifiant de la configuration */
    idConfig: number;

    /** Indique si l'application mobile est activée */
    available: boolean;

    /** Indique si la double authentification est activée */
    doubleAuthentication: boolean;

    /** Indique si le code PIN est obligatoire */
    codePIN: boolean;

    /** Indique si les notifications push sont activées */
    pushNotification: boolean;

    /** URL du MobileHub */
    mobileHubUrl: string;

    /** Version des fonctionnalités activées par défaut */
    defaultVersion: TypeVersion;

    /**
     * Constructeur
     *
     * @param config Données issues du back à recopier (facultatif)
     */
    constructor(config?: Partial<MobileConfig>) {
        //Recopie des propriétés reçues du back
        if (config) {
            Object.assign(this,config);
        }
    }
}
